module.exports = __webpack_public_path__ + "assets/img/mecha-btn-d840e4e3.png";